import $ from 'jquery';
// require("jquery-mousewheel")($);

/**
 * Custom Scripts
 */
//import MarsLoadMorePosts from './modules/mars-load-more-posts';
import SinglePageUpdown from './modules/single-page-updown';
import MarsFormScripts from './modules/mars-forms';
import AppWebApiUtilities from './modules/app-web-api-utilities';
import MarsSlideshows from './modules/mars-slideshow';
import Menu from './modules/menu-overlay';
import MainSearch from './modules/search-header';
import SiteSearch from './modules/search-body';
import BioOverlay from './modules/profile-overlay';
import ServiceSearch from './modules/services-script';
import ServiceLevels from './modules/service-level';
import MaRSPartnerTypes from './modules/partner-types-script';
import EventSearch from './modules/events-script';
import MarsSMagazine from './modules/magazine-script';
import CareerSearch from './modules/careers-script';
import CareerMondayVC from './modules/latest-monday-vc-jobs';
import VentureSearch from './modules/ventures-script';
import VenturePartner from './modules/venture-partner-script';
import VentureBySector from './modules/ventures-by-sector';
import ResearchInsight from './modules/research-insight';
import MaRSReports from './modules/report-script';
import MaRSTenants from './modules/tenant-script';
import MaRSMediaPress from './modules/media-press-script';
import MaRSAnim from './modules/mars-animations';
import countTo from './modules/number-count';
import mobTabs from './modules/mobile-tabs';
import HeaderScroll from './modules/header-scroll';
import MaRSscripts from './modules/mars-scripts';
import Toggles from './modules/toggles';
import FeaturedImageSlider from './modules/sector-page-header';
import StoryProgressBar from './modules/single_story';
import GoogleMap from './modules/connect-with-us';
import FullScreenVideo from './modules/quotes-testimonial-video-block';
import GlobalPopup from './modules/mars-popup';
import TemplateLayouts from './modules/marketingTemplateLayouts';
import MaRSCovid from './modules/covid-script';
import MaRSMomentum from './modules/momentum-script';
import MaRSNewsSeries from './modules/news-series';
import VcVentureSearch from './modules/vc-ventures-script';



/**
 * Vendors
 */
/*import scrollme from './vendors/scrollme';*/
import Bootstrap from './vendors/bootstrap';
//import matchHeight from './vendors/jquery.matchHeight';
// import paceLoad from './vendors/pace.min';
import SimpleBar from './vendors/simplebar';


jQuery(document).ready(function ($) {

  let MarsScripts = new MaRSscripts();
  let SecondaryMenu = new Menu();
  let Search = new MainSearch();
  let SearchSite = new SiteSearch();
  let pOverlay = new BioOverlay();
  let serviceLoad = new ServiceSearch();
  let serviceLevelLoad = new ServiceLevels();
  let PartnerTypes = new MaRSPartnerTypes();
  let eventLoad = new EventSearch();
  let magazineLoad = new MarsSMagazine();
  let careerLoad = new CareerSearch();
  let careerMondayVCLatest = new CareerMondayVC();
  let ventureLoad = new VentureSearch();
  let venturePartnerTab = new VenturePartner();
  let ventureSectorTab = new VentureBySector();
  let researchInsightTab = new ResearchInsight();
  let reportsResults = new MaRSReports();
  let tenantsResults = new MaRSTenants();
  let mediapressResults = new MaRSMediaPress();
  let marsAnimations = new MaRSAnim();
  let Slides = new MarsSlideshows();
  let mTabs = new mobTabs();
  let mToggles = new Toggles();
  let featuredImageSlider = new FeaturedImageSlider();
  let storyProgressBar = new StoryProgressBar();
  let googleMap = new GoogleMap();
  let fullScreenVideo = new FullScreenVideo();
  let globalPopup = new GlobalPopup();
  let templateLayouts = new TemplateLayouts();
  //let ProgramsCta = new ProgramsCta();
  //let Events = new Events();
  let RegisterFormScripts = new MarsFormScripts();
  //let WebApiUtilities = new AppWebApiUtilities();
  let maRSCovid = new MaRSCovid();
  let maRSMomentum = new MaRSMomentum();
  let maRSNewsSeries = new MaRSNewsSeries();
  let vcVentureSearch = new VcVentureSearch();

  /* Header Scroll */
  let MainHeaderScroll = new HeaderScroll({
    header: $(".header--collapse"),
    threshold: 300,
    class: 'header--collapsed'
  });

  $('.nav-tabs a').on('click', function (e) {
    e.preventDefault()
    $(this).tab('show');
  });

  $('.allCareers__venture').popover({
    trigger: 'hover'
  });

  $('.fsSaveIncomplete').on('click', function (e) {
    e.preventDefault();
    let el = document.querySelectorAll(".singleInternalPage__title");
    el = el[el.length - 1];
    let offset = $(el).offset();
    $('html, body').animate({
      scrollTop: offset.top - 100,
      scrollLeft: offset.left
    });
  });
});